import { render } from "./WelcomeProfileInfo.vue?vue&type=template&id=3b38d1dc&scoped=true"
import script from "./WelcomeProfileInfo.vue?vue&type=script&lang=js"
export * from "./WelcomeProfileInfo.vue?vue&type=script&lang=js"

import "./WelcomeProfileInfo.vue?vue&type=style&index=0&id=3b38d1dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b38d1dc"]])

export default __exports__